import { Helmet } from 'react-helmet';
import ReactDOM from 'react-dom';
import { Link, useLocation, useNavigate } from "react-router-dom";
import { notifications } from '@mantine/notifications';
import {
  createStyles,
  Header,
  Group,
  Button,
  UnstyledButton,
  Text,
  Divider,
  Center,
  Box,
  Burger,
  Drawer,
  Collapse,
  Menu,
  ActionIcon,
  useMantineColorScheme,
  Anchor,
  Popover,
  Flex,
  ColorSwatch,
  Grid,
  Modal,
  FileInput
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import {
  IconChevronDown,
  IconUser,
  IconCurrencyDollar,
  IconHelp,
  IconMessage2Share,
  IconLogout,
  IconSun,
  IconMoon,
  IconBell,
  IconUpload,
  IconX,
  IconChartBar,
  IconRocket
} from "@tabler/icons-react";
import visioptLogo from '../../img/visiopt-small-logo.webp';
import { useEffect, useState, useRef } from 'react';
import { visiUserSession, setVisiUserSession,visiUserId, isAdLookupRole } from '../../GeneralFunction';
import { SelectMemberWebsiteList, SelectTooltip, VisiLoader, useColorScheme, UpdateMessages } from "../GeneralComponent/GeneralComponent";
import PermissionWrapper from '../../PermissionWrapper';
import { useAuth } from '../../AuthContext';
import GeneralComponentApi from "../../api/GeneralComponentApi";

const useStyles = createStyles((theme) => ({
  link: {
    display: "flex",
    alignItems: "center",
    height: "100%",
    paddingLeft: theme.spacing.md,
    paddingRight: theme.spacing.md,
    textDecoration: "none !important",
    // color: theme.colorScheme === "dark" ? theme.white : theme.black,
    fontWeight: 500,
    fontSize: theme.fontSizes.sm,

    [theme.fn.smallerThan("sm")]: {
      height: 42,
      display: "flex",
      alignItems: "center",
      width: "100%"
    },

    ...theme.fn.hover({
      backgroundColor:
        theme.colorScheme === "dark"
          ? theme.colors.gray[8]
          : theme.colors.gray[0],
      height: "50%",
      borderRadius: "5px"
    })
  },

  hiddenMobile: {
    [theme.fn.smallerThan("sm")]: {
      display: "none"
    }
  },

  hiddenDesktop: {
    [theme.fn.largerThan("sm")]: {
      display: "none"
    }
  },

  activeLink: {
    backgroundColor:
        theme.colorScheme === "dark"
          ? theme.colors.gray[8]
          : theme.colors.gray[0],
    height: "50%",
    borderRadius: "5px"
  }
}));

export function HeaderMenu({ HeaderMenuValue, HeaderMenuOnChange, refreshHeaderMenu }:any) {

  const [selectedMemberWebsite, setSelectedMemberWebsite] = useState('');
  let websiteId = visiUserSession().website ? visiUserSession().website : '';
  const handleSelectMemberWebsiteListComponentChange = (HeaderMenuValue:any) => {
    setSelectedMemberWebsite(HeaderMenuValue);
    HeaderMenuOnChange(HeaderMenuValue);
  };

  useEffect(() => {
    setSelectedMemberWebsite(websiteId);
  }, []);

  const navigate = useNavigate();
  const { userRolePermissions } = useAuth();

  const location = useLocation().pathname;

/*  const oldClientUrl = process.env.REACT_APP_OLD_VISIOPT_BASE_URL.replace("app", "client");
  const landingurl = oldClientUrl+'index.php?pag=landing';*/
  setVisiUserSession('page', location);
  const { colorScheme, toggleColorScheme } = useMantineColorScheme();
  const dark = colorScheme === "dark";

  useEffect(() => {
    const visicolorscheme = localStorage.getItem('visicolorscheme');
    if ((visicolorscheme === 'light' || visicolorscheme === 'dark') && visicolorscheme !== colorScheme) {
      toggleColorScheme(visicolorscheme);
    }else{
      localStorage.setItem('visicolorscheme', colorScheme);
    }
  }, [colorScheme]);

  const handleToggleColorScheme = () => {
    const newColorScheme = colorScheme === 'light' ? 'dark' : 'light';
    toggleColorScheme(newColorScheme);
    localStorage.setItem('visicolorscheme', newColorScheme);
  };

  const [
    drawerOpened,
    { toggle: toggleDrawer, close: closeDrawer }
  ] = useDisclosure(false);
  const [TestslinksOpened, { toggle: toggleTestsLinks }] = useDisclosure(false);
  const [CampaignslinksOpened, { toggle: toggleCampaignsLinks }] = useDisclosure(false);
  const [ReportslinksOpened, { toggle: toggleReportsLinks }] = useDisclosure(false);
  const [InsightslinksOpened, { toggle: toggleInsightsLinks }] = useDisclosure(false);
  const { classes, theme } = useStyles();

  const [NotificationPopOverOpened, setNotificationPopOverOpened] = useState(false);

  const [notificationCount, setNotificationCount] = useState(0);
  const [MemberNotificationList, setMemberNotificationList] = useState([]);

  const [MemberAllNotificationList, setMemberAllNotificationList] = useState([]);
  const [memberShortName, setMemberShortName] = useState(null);
  const [sendFeedbackValue, setSendFeedbackValue] = useState('');
  const [SendFeedbackModalOpen, setSendFeedbackModalOpen] = useState(false);
  const [fileInputs, setFileInputs] = useState(["file-0"]);
  const [files, setFiles] = useState([{ index: 0, name: "", type: "", file: null }]);
  const feedbackIconRef = useRef(null);
  const feedbackSuccessIconRef = useRef(null);
  const [showHelpModal, setShowHelpModal] = useState(false);
  const [helpTargetId, setHelpTargetId] = useState(0);
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });
  const [SendFeedbackSuccessModelOpen, setSendFeedbackSuccessModelOpen] = useState(false);
  const [feedbackSuccessMsg, setFeedbackSuccessMsg] = useState('');
  const [feedbackthanksMsg, setFeedbackthanksMsg] = useState('');
  const [isLoaderVisible, setIsLoaderVisible] = useState(false);
  const notificationIconRef = useRef(null);
  const colorTheme = useColorScheme();
  const [isFeedbackLoaderVisible, setIsFeedbackLoaderVisible] = useState(false);

  const [updateMessageModel, setUpdateMessagesModel] = useState(false);
  const [updateMessages, setUpdateMessages] = useState([]);
  const [loginMemberStatus, setLoginMemberStatus] = useState("");

  const handleAddInput = () => {
    if (fileInputs.length < 3) {
      setFileInputs([...fileInputs, `file-${fileInputs.length}`]);
    }
  };

  const handleRemoveInput = (index) => {
    setFileInputs((prev) => prev.filter((_, i) => i !== index));
    setFiles((prevFiles) => {
      const updatedFiles = prevFiles.filter((_, i) => i !== index);
      return updatedFiles.map((file, newIndex) => ({ ...file, index: newIndex }));
    });

  };

  const handleFileChange = (file, index) => {
    setFiles(prevData => {
      const fileExists = prevData.some(entry => entry.index === index);
      if (fileExists) {
        return prevData.map(entry => 
            entry.index === index
                ? { ...entry, name: file.name, type: file.type, file: file }
                : entry 
        );
      }else {
        const updatedData = [
            ...prevData,
            { index: index, name: file.name, type: file.type, file: file }
        ];
        return updatedData;
      }
    });
  };

  const handleHelpClick = (id:any, value:any) => {
    setShowHelpModal(true);
    setHelpTargetId(id);
    const refMapping = {
      "init": feedbackIconRef,
      "success": feedbackSuccessIconRef,
      'notification':notificationIconRef
    }
    const iconRef = refMapping[value];
    if (iconRef.current) {
      const { top, left, width } = iconRef.current.getBoundingClientRect();
      const scrollOffset = window.scrollY;
      setTooltipPosition({
        top: top + scrollOffset,
        left: left + width + 10, 
      });
    }
  };

  /*Send FeedBack*/
  const handleSendFeedbackOpenModal = (value:any) => {
    setSendFeedbackModalOpen(true);
  };

  const handleSendFeedbackCloseModal = () => {
    setSendFeedbackModalOpen(false);
    setSendFeedbackValue('');
    setFiles([]);
    setFileInputs(["file-0"]);
  };

  const handleFeedbackValueChange = (value:any) => {
    setSendFeedbackValue(value);
  };

  const handleSendFeedbackSubmit = async () => {
    const formData = new FormData();
    formData.append("feedback", sendFeedbackValue);
    formData.append("member_id", visiUserId());

    files.forEach((fileData, index) => {
      if (fileData.file) {
        formData.append(`files[]`, fileData.file);
      }
    });

    let url = "send_feedback";
    setIsFeedbackLoaderVisible(true);
    await fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, {
      method: "POST",
      body: formData
    }).then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          setIsLoaderVisible(false);
          navigate("/login");
          setIsFeedbackLoaderVisible(false);
        }
      }
    }).then(data => {
      if(data.status === 1){
        setSendFeedbackModalOpen(false);
        setSendFeedbackSuccessModelOpen(true);
        setFeedbackSuccessMsg(data.message);
        setFeedbackthanksMsg(data.data.thank_you_msg);
        setIsLoaderVisible(false);
        setIsFeedbackLoaderVisible(false);
      }else if(data.status === 0){
        setIsFeedbackLoaderVisible(false);
        notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: data.message,
        });
      }
    }).catch(error => {
      console.log(error);
      setIsLoaderVisible(false);
      setIsFeedbackLoaderVisible(false);
    });
  };
    
  const handleSendFeedbackSuccessModelClose = () => {
    setSendFeedbackSuccessModelOpen(false);
    setSendFeedbackValue('');
    setFiles([]);
    setFileInputs(["file-0"]);
  };

  useEffect(() => {
    if(NotificationPopOverOpened){
      GeneralComponentApi.getmembernotificationlist({
        notification_limit : 3
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/login");
          }
        }
      })
      .then(data => {
        if(data.status === 1){
          setMemberNotificationList(data.data || []);
        }
      })
      .catch(error => {
        console.log(error);
      });
    }
  }, [NotificationPopOverOpened, navigate]);

  const handleMemberNotificationsCount = () => {
    GeneralComponentApi.getmembernotificationlist({
        notification_limit : 3
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/login");
          }
        }
      })
      .then(data => {
        if(data.status === 1){
          const count = data.data.filter(item => item.status === "1").length;
          setNotificationCount(count);
        }
      })
      .catch(error => {
        console.log(error);
      });
  };

  const [isSeeAllMemberNotificationsOpen, setIsSeeAllMemberNotificationsOpen] = useState(false);

  const handleSeeAllMemberNotificationsModal = () => {
    setIsSeeAllMemberNotificationsOpen(false);
  };

  const SeeAllMemberNotifications = () => {
    setNotificationPopOverOpened(false);
    setIsSeeAllMemberNotificationsOpen(true);
  };

  useEffect(() => {
    if(isSeeAllMemberNotificationsOpen){
      GeneralComponentApi.getmembernotificationlist()
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/login");
          }
        }
      })
      .then(data => {
        if(data.status === 1){
          setMemberAllNotificationList(data.data || []);
          const count = data.data.filter(item => item.status === "1").length;
          setNotificationCount(count);
        }
      })
      .catch(error => {
        console.log(error);
      });
    }
  }, [isSeeAllMemberNotificationsOpen, navigate]);

  useEffect(() => {
    handleMemberNotificationsCount();
  }, []);

  const handleStatusUpdate = (id) => {
    if(id !== ''){
      GeneralComponentApi.getmembernotificationlist({
          notification_status : "notification_update",
          id :id
        })
       .then(response => {
          if (response.ok) {
            return response.json();
          } else {
            if (response.status === 401 || response.status === 400) {
              navigate("/login");
            }
          }
        })
      .then(data => {
        if(data.status === 1){
            setNotificationPopOverOpened(false);
            handleMemberNotificationsCount();
        }
      })
      .catch(error => {
          console.log(error);
      });
    }
  }

  useEffect(() => {
    GeneralComponentApi.getmemberuserpermission()
    .then(response => {
      if (response.ok) {
        return response.json();
      }
    })
    .then(data => {
      if(data.status === 1){
        userRolePermissions(JSON.parse(atob(data.data.user_permission_data)));
        setLoginMemberStatus(data.data.login_member_status);
        if(data.data.first_time_login === '1'){
          navigate('/account_setup');
        }
        if(data.data.login_member_status === '3'){
          navigate('/billing-details');
        }
      }
    })
    .catch(error => {
      console.log(error);
    });
  }, []);

  useEffect(() => {
    if(localStorage.getItem('visiUserData') !== null){
      const userDataString = atob(localStorage.getItem('visiUserData'));
      const userData = JSON.parse(userDataString);
      if (userData) {
        setMemberShortName(userData.member_short_name);
      }
    }
  }, []);

  useEffect(() => {
    GeneralComponentApi.getupdatemessages({
      member_id : visiUserId()
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/login");
        }
      }
    })
    .then(data => {
      if(data && data.status === 1){
        setUpdateMessages(data.data || []);
        setUpdateMessagesModel(true);
      } else {
        setUpdateMessagesModel(false);
      }
    })
    .catch(error => {
      console.log(error);
    });
  }, []);

  return (
    <>
    <VisiLoader VisiLoaderVisible={isLoaderVisible} />
    <Helmet>
      {theme.colorScheme === "dark"?'':<style>{`body {background-color: #f8f9fb;}`}</style>}
    </Helmet>
      {showHelpModal &&
      ReactDOM.createPortal(
        <div style={{ zIndex: 9999 }}>
          <SelectTooltip
            isVisible={showHelpModal}
            setIsVisible={setShowHelpModal}
            id={helpTargetId}
            tooltipPosition={tooltipPosition}
          />
        </div>,
        document.body
      )}
      <Modal.Root size={1100} opened={isSeeAllMemberNotificationsOpen} onClose={handleSeeAllMemberNotificationsModal} trapFocus={false}>
        <Modal.Overlay />
        <Modal.Content>
          <Modal.Header>
            <Modal.Title><Text weight={500}>NOTIFICATION <IconHelp ref={notificationIconRef} size="1.1rem" color="red" style={{marginBottom:-3, cursor: 'pointer'}}  onClick={() => handleHelpClick(176,'notification')}/></Text></Modal.Title>
            <Modal.CloseButton />
          </Modal.Header>
          <Modal.Body>
            {MemberAllNotificationList.map(Notification => (
              <>
                <Text weight={500} fz="sm">{Notification.title}</Text>
                <Text dangerouslySetInnerHTML={{ __html: Notification.description }} fz="sm"></Text>
                <Flex
                  justify="flex-end"
                >
                  <Text fz="sm">{Notification.date}</Text>
                </Flex>
                <Divider my={10} />
              </>
            ))}
          </Modal.Body>
        </Modal.Content>
      </Modal.Root>

      <Modal.Root size={700} opened={SendFeedbackModalOpen} onClose={handleSendFeedbackCloseModal} trapFocus={false}>
        <Modal.Overlay />
        <Modal.Content>
          <VisiLoader VisiLoaderVisible={isFeedbackLoaderVisible} />
          <Modal.Header>
            <Modal.Title><Text weight={500}>Send Feedback <IconHelp ref={feedbackIconRef} size="1.1rem" color="red" style={{marginBottom:-3, cursor: 'pointer'}} onClick={() => handleHelpClick(129, 'init')}/></Text></Modal.Title>
            <Modal.CloseButton />
          </Modal.Header>
          <Modal.Body>
            {/* Add Feedback Heading */}
            <Text size={25} weight={500} >Your feedback is very welcome</Text>
            <Text size = {11} color={colorTheme === "light" ? "gray" : "#a9a9a9"} weight={700}>
              Please give us your feedback concerning the usability and functionality of our product
            </Text>

            {/* Feedback Input */}
            <textarea name="postContent" value={sendFeedbackValue} onChange={(e) => handleFeedbackValueChange(e.currentTarget.value)} rows={10} cols={100} style={{ width: "100%", height: "220px" }} />

            {/* File Upload */}
            <Text size = {11} color={colorTheme === "light" ? "gray" : "#a9a9a9"} weight={700} style={{ marginBottom: "8px" }}>You can also attach pictures to this message (only .jpg, .jpeg, .gif)</Text>

            {fileInputs.map((id, index) => (
            <Group key={id} mt="md">
              <FileInput                
                style={{ width: "45%" }}
                onChange={(file) => handleFileChange(file, index)}
                value={files.find((data) => data.index === index)?.file || null}
                icon={<IconUpload size={10} />}
              />

              {index > 0 && (
                <Button color="red" size="xs" onClick={() => handleRemoveInput(index)} style={{ marginLeft: 260 }}>
                  Remove
                </Button>
              )}

              {index === 0 && fileInputs.length <= 3 && (
                <Button variant="light" color="blue" size="xs" onClick={handleAddInput} style={{ marginLeft: 190 }}>
                  Add another (max. 3)
                </Button>
              )}
            </Group>
          ))}
  
         <Flex
            gap="md"
            justify="flex-end"
            style={{ marginTop: "20px" }}
          >
          <Button size="xs" color="red" onClick={handleSendFeedbackCloseModal}>Cancel</Button>
          <Button size="xs" onClick={handleSendFeedbackSubmit}>Submit</Button>
        </Flex>

          </Modal.Body>
        </Modal.Content>
      </Modal.Root>

      <Modal.Root size={700} opened={SendFeedbackSuccessModelOpen} onClose={handleSendFeedbackSuccessModelClose} trapFocus={false}>
        <Modal.Overlay />
        <Modal.Content>
          <Modal.Header>
            <Modal.Title><Text weight={500}>Send Feedback <IconHelp ref={feedbackSuccessIconRef} size="1.1rem" color="red" style={{marginBottom:-3, cursor: 'pointer'}} onClick={() => handleHelpClick(129, 'success')}/></Text></Modal.Title>
            <Modal.CloseButton />
          </Modal.Header>
          <Modal.Body>
            <Text size={25} weight={500} >{feedbackSuccessMsg}</Text>
              <Text size = {15}  weight={400}  style={{ marginTop: "20px" }}>{feedbackthanksMsg}</Text>
          </Modal.Body>
        </Modal.Content>
      </Modal.Root>

      <UpdateMessages updateMessages={updateMessages} updateMessageModel={updateMessageModel} setUpdateMessagesModel={setUpdateMessagesModel}/>
      <Box pb={10}>
        <Header height={50} px="md">
          <Group position="apart" sx={{ height: "100%", flexWrap: "nowrap" }}>
            <Group
              sx={{ height: "100%", flexShrink: 0, overflowX: "auto", whiteSpace: "nowrap" }}
              spacing={5}
              className={classes.hiddenMobile}
            >
              <img src={visioptLogo } alt="Company Logo"/>
              {!isAdLookupRole() && (
                <Link to="/dashboard" style={{color: dark ? "white" : "black",pointerEvents: loginMemberStatus === '3' ? "none" : "auto"}} className={`${classes.link} ${location === "/dashboard" ? classes.activeLink : ""}`}>Dashboard</Link>
              )}
              {!isAdLookupRole() && (
                <Link to={selectedMemberWebsite.trim() !== '' ? "/funnels" : "/settings"} style={{color: dark ? "white" : "black",pointerEvents: loginMemberStatus === '3' ? "none" : "auto"}} className={`${classes.link} ${location === "/funnels" ? classes.activeLink : ""}`}>Funnels</Link>
              )}
              {!isAdLookupRole() && (
                <Menu shadow="md" width={200} trigger="hover" withinPortal>
                  <Menu.Target>
                    <Button variant="transparent" color="dark" style={{color: dark ? "white" : "black"}}>Tests<IconChevronDown size="1rem"/></Button>
                  </Menu.Target>
                  <Menu.Dropdown>
                    <Link to={selectedMemberWebsite.trim() !== '' ? "/review-tests" : "/settings"} style={{color: dark ? "white" : "black",textDecoration: "none",pointerEvents: loginMemberStatus === '3' ? "none" : "auto"}}><Menu.Item>Review Tests</Menu.Item></Link>
                    <Link to={selectedMemberWebsite.trim() !== '' ? "/create-test" : "/settings"} style={{color: dark ? "white" : "black",textDecoration: "none",pointerEvents: loginMemberStatus === '3' ? "none" : "auto"}}><Menu.Item>Create Test</Menu.Item></Link>
                    <Link to={selectedMemberWebsite.trim() !== '' ? "/test-history" : "/settings"} style={{color: dark ? "white" : "black",textDecoration: "none",pointerEvents: loginMemberStatus === '3' ? "none" : "auto"}}><Menu.Item>Test History</Menu.Item></Link>
                  </Menu.Dropdown>
                </Menu>
              )}
              <PermissionWrapper permission="campaign_tab">
                <Menu shadow="md" width={200} trigger="hover" withinPortal>
                  <Menu.Target>
                    <Button variant="transparent" color="dark" style={{color: dark ? "white" : "black"}}>Campaigns<IconChevronDown size="1rem"/></Button>
                  </Menu.Target>
                  <Menu.Dropdown>
                    <PermissionWrapper permission="campaign_tab_access">
                      <Link to={selectedMemberWebsite.trim() !== '' ? "/manage-campaigns" : "/settings"} style={{color: dark ? "white" : "black",textDecoration: "none",pointerEvents: loginMemberStatus === '3' ? "none" : "auto"}}><Menu.Item>Manage Campaigns</Menu.Item></Link>
                      <Menu trigger="hover" position="right-start" offset={0}>
                        <Menu.Target>
                          <Menu.Item rightSection="›">Reports</Menu.Item>
                        </Menu.Target>
                        <Menu.Dropdown>
                          <Link to={selectedMemberWebsite.trim() !== '' ? "/campaign-reports" : "/settings"} style={{color: dark ? "white" : "black",textDecoration: "none",pointerEvents: loginMemberStatus === '3' ? "none" : "auto"}}><Menu.Item>Campaign Reports</Menu.Item></Link>
                          <Link to={selectedMemberWebsite.trim() !== '' ? "/aggregated-reports" : "/settings"} style={{color: dark ? "white" : "black",textDecoration: "none",pointerEvents: loginMemberStatus === '3' ? "none" : "auto"}}><Menu.Item>Aggregated Report</Menu.Item></Link>
                        </Menu.Dropdown>
                      </Menu>
                    </PermissionWrapper>
                    <PermissionWrapper permission="add_lookup_access">
                     <Link to={selectedMemberWebsite.trim() !== '' ? "/ad-lookup" : "/settings"} style={{color: dark ? "white" : "black",textDecoration: "none",pointerEvents: loginMemberStatus === '3' ? "none" : "auto"}}><Menu.Item>Ad Lookup</Menu.Item></Link>
                     </PermissionWrapper>
                  </Menu.Dropdown>
                </Menu>
              </PermissionWrapper>
              <Menu shadow="md" width={200} trigger="hover" withinPortal>
                <PermissionWrapper permission="insights_tab">
                <Menu.Target>
                  <Button variant="transparent" color="dark" style={{color: dark ? "white" : "black"}}>Insights<IconChevronDown size="1rem"/></Button>
                </Menu.Target>
                </PermissionWrapper>
                <Menu.Dropdown>
                  <PermissionWrapper permission="heat_maps_access">
                    <Link to={selectedMemberWebsite.trim() !== '' ? "/heat-maps" : "/settings"} style={{color: dark ? "white" : "black",textDecoration: "none",pointerEvents: loginMemberStatus === '3' ? "none" : "auto"}}><Menu.Item>Heat Maps</Menu.Item></Link>
                  </PermissionWrapper>
                  <PermissionWrapper permission="scroll_maps_access">
                    <Link to={selectedMemberWebsite.trim() !== '' ? "/scroll-maps" : "/settings"} style={{color: dark ? "white" : "black",textDecoration: "none",pointerEvents: loginMemberStatus === '3' ? "none" : "auto"}}><Menu.Item>Scroll Maps</Menu.Item></Link>
                  </PermissionWrapper>
                  <PermissionWrapper permission="recordings_access">
                    <Link to={selectedMemberWebsite.trim() !== '' ? "/recordings" : "/settings"} style={{color: dark ? "white" : "black",textDecoration: "none",pointerEvents: loginMemberStatus === '3' ? "none" : "auto"}}><Menu.Item>Recordings</Menu.Item></Link>
                  </PermissionWrapper>
                </Menu.Dropdown>
              </Menu>
{/*              <PermissionWrapper permission="langing_page_tab_access">
                <Link to={landingurl} style={{color: dark ? "white" : "black"}} className={`${classes.link}`}>Landing Pages</Link>
              </PermissionWrapper>*/}
              {!isAdLookupRole() && (
                <PermissionWrapper permission="operational_access">
                  {/*<Link to="/landing-pages" style={{color: dark ? "white" : "black"}} className={`${classes.link} ${location === "/landing-pages" ? classes.activeLink : ""}`}>Landing Pages</Link>*/}
                  <Link to="/settings" style={{color: dark ? "white" : "black",pointerEvents: loginMemberStatus === '3' ? "none" : "auto"}} className={`${classes.link} ${location === "/settings" ? classes.activeLink : ""}`}>Settings</Link>
                </PermissionWrapper>
              )}
            </Group>
            <Group
              sx={{ height: "100%", flexShrink: 0 }}
              spacing={10}
              className={classes.hiddenMobile}
            >
            <SelectMemberWebsiteList SelectMemberWebsiteListValue={selectedMemberWebsite} SelectMemberWebsiteListOnChange={handleSelectMemberWebsiteListComponentChange} SelectMemberWebsiteListUsedIn="HeaderMenu" refreshMemberWebsiteList={refreshHeaderMenu}/>
            <Popover opened={NotificationPopOverOpened} onChange={setNotificationPopOverOpened} width={450} position="bottom" withArrow shadow="md" withinPortal>
              <Popover.Target>
                <ActionIcon
                  variant="default"
                  size="lg"
                  color={dark ? 'yellow' : 'blue'}
                  onClick={() => setNotificationPopOverOpened((o) => !o)}
                  title="Notification"
                >
                  <IconBell  size="1.1rem" fill={notificationCount > 0 ? "#ff0000" : "none"} />
                </ActionIcon>
              </Popover.Target>
              <Popover.Dropdown>
                <Text weight={500}>Notifications</Text>
                <Divider my={10} />
                {MemberNotificationList.map(Notification => (
                  <>
                  <Grid>
                    <Grid.Col span={11}>
                      <Text weight={500} fz="sm">{Notification.title}</Text>
                    </Grid.Col>
                    <Grid.Col span={1}>
                      <Flex
                        justify="flex-end"
                      >
                        {Notification.status === '0' && <ColorSwatch color="#a1a1a1" w={17} h={17} onClick={() => handleStatusUpdate(Notification.id)} style={{ cursor: "pointer" }} />}
                        {Notification.status === '1' && <ColorSwatch color="#ff0000" w={17} h={17} onClick={() => handleStatusUpdate(Notification.id)} style={{ cursor: "pointer" }} />}
                      </Flex>
                    </Grid.Col>
                  </Grid>
                    <Text dangerouslySetInnerHTML={{ __html: Notification.description }} fz="sm"></Text>
                    <Flex
                      justify="flex-end"
                    >
                      <Text fz="sm">{Notification.date}</Text>
                    </Flex>
                    <Divider my={10} />
                  </>
                ))}
                <Flex
                  justify="center"
                >
                <Anchor weight={500} fz="sm" onClick={SeeAllMemberNotifications}>See All</Anchor>
                </Flex>
              </Popover.Dropdown>
            </Popover>
            <ActionIcon
              variant="default"
              size="lg"
              color={dark ? 'yellow' : 'blue'}
              onClick={() => handleToggleColorScheme()}
              title="Toggle color scheme"
            >
              {dark ? <IconSun size="1.1rem" /> : <IconMoon size="1.1rem" />}
            </ActionIcon>
            <Menu shadow="md" trigger="hover" withinPortal>
              <Menu.Target>
                <Button variant="default" color="dark">{memberShortName}<IconChevronDown size="0.9rem" stroke={1.5} /></Button>
              </Menu.Target>
              <Menu.Dropdown>
                {!isAdLookupRole() && (
                  <PermissionWrapper permission="operational_access">
                    <Link to="/settings" state={{ from: 'my_account' }} style={{color: dark ? "white" : "black",textDecoration: "none",pointerEvents: loginMemberStatus === '3' ? "none" : "auto"}}><Menu.Item icon={<IconUser size={14} />}>My Account</Menu.Item></Link>
                  </PermissionWrapper>
                )}
                <Link to="/system-usage" style={{color: dark ? "white" : "black",textDecoration: "none",pointerEvents: loginMemberStatus === '3' ? "none" : "auto"}}><Menu.Item icon={<IconChartBar size={14} />}>System Usage</Menu.Item></Link>
                {!isAdLookupRole() && (
                  <PermissionWrapper permission="billing_portal_access,operational_access">
                    <Link to="/billing-details" style={{color: dark ? "white" : "black",textDecoration: "none"}}><Menu.Item icon={<IconCurrencyDollar size={14} />}>Billing Details</Menu.Item></Link>
                  </PermissionWrapper>
                )}
                {!isAdLookupRole() && (
                  <PermissionWrapper permission="operational_access">
                    <Link to="/onboarding?mode=guided" style={{color: dark ? "white" : "black",textDecoration: "none",pointerEvents: loginMemberStatus === '3' ? "none" : "auto"}}><Menu.Item icon={<IconRocket size={14} />}>Guided Setup</Menu.Item></Link>
                  </PermissionWrapper>
                )}
                <Menu.Item icon={<IconHelp size={14} />} component="a" href="https://visiopt.com/help-videos.html" target="_blank" style={{ pointerEvents: loginMemberStatus === '3' ? "none" : "auto" }}>Help</Menu.Item>
                <PermissionWrapper permission="operational_access">
                  <Link to="#" onClick={() => handleSendFeedbackOpenModal(0)} style={{color: dark ? "white" : "black",textDecoration: "none",pointerEvents: loginMemberStatus === '3' ? "none" : "auto"}}><Menu.Item icon={<IconMessage2Share size={14} />}>Send Feedback</Menu.Item></Link>
                </PermissionWrapper>
                <Link to="/logout" style={{color: dark ? "white" : "black",textDecoration: "none"}}><Menu.Item icon={<IconLogout size={14} />}>Logout</Menu.Item></Link>
              </Menu.Dropdown>
            </Menu>
            </Group>

            <Burger
              opened={drawerOpened}
              onClick={toggleDrawer}
              className={classes.hiddenDesktop}
            />
          </Group>
        </Header>

        <Drawer
          opened={drawerOpened}
          onClose={closeDrawer}
          size="100%"
          padding="md"
          title="Navigation"
          className={classes.hiddenDesktop}
          zIndex={1000000}
        >
          <Divider
            my="sm"
            color={theme.colorScheme === "dark" ? "dark.5" : "gray.1"}
          />

          <UnstyledButton className={classes.link}>
            <Text className={classes.link}>
              <Link to="/dashboard" style={{color: dark ? "white" : "black",textDecoration: "none",pointerEvents: loginMemberStatus === '3' ? "none" : "auto"}}>Dashboard</Link>
            </Text>
          </UnstyledButton>
          <UnstyledButton className={classes.link}>
            <Text className={classes.link}>
              <Link to={selectedMemberWebsite.trim() !== '' ? "/funnels" : "/settings"} style={{color: dark ? "white" : "black",textDecoration: "none",pointerEvents: loginMemberStatus === '3' ? "none" : "auto"}}>Funnels</Link>
            </Text>
          </UnstyledButton>
          <UnstyledButton className={classes.link} onClick={toggleTestsLinks}>
            <Center inline>
              <Box component="span" mr={5}>
                Tests
              </Box>
              <IconChevronDown size={16} color={theme.fn.primaryColor()} />
            </Center>
          </UnstyledButton>
          <Collapse in={TestslinksOpened}>
            <UnstyledButton className={classes.link}>
              <Text className={classes.link}>
                <Link to={selectedMemberWebsite.trim() !== '' ? "/review-tests" : "/settings"} style={{color: dark ? "white" : "black",textDecoration: "none",pointerEvents: loginMemberStatus === '3' ? "none" : "auto"}}>Review Tests</Link>
              </Text>
            </UnstyledButton>
            <UnstyledButton className={classes.link}>
              <Text className={classes.link}>
                <Link to={selectedMemberWebsite.trim() !== '' ? "/create-test" : "/settings"} style={{color: dark ? "white" : "black",textDecoration: "none",pointerEvents: loginMemberStatus === '3' ? "none" : "auto"}}>Create Test</Link>
              </Text>
            </UnstyledButton>
            <UnstyledButton className={classes.link}>
              <Text className={classes.link}>
                <Link to={selectedMemberWebsite.trim() !== '' ? "/test-history" : "/settings"} style={{color: dark ? "white" : "black",textDecoration: "none",pointerEvents: loginMemberStatus === '3' ? "none" : "auto"}}>Test History</Link>
              </Text>
            </UnstyledButton>
          </Collapse>
          <PermissionWrapper permission="campaign_tab_access">
            <UnstyledButton className={classes.link} onClick={toggleCampaignsLinks}>
              <Center inline>
                <Box component="span" mr={5}>
                  Campaigns
                </Box>
                <IconChevronDown size={16} color={theme.fn.primaryColor()} />
              </Center>
            </UnstyledButton>
            <Collapse in={CampaignslinksOpened}>
              <UnstyledButton className={classes.link}>
                <Text className={classes.link}>
                  <Link to={selectedMemberWebsite.trim() !== '' ? "/manage-campaigns" : "/settings"} style={{color: dark ? "white" : "black",textDecoration: "none",pointerEvents: loginMemberStatus === '3' ? "none" : "auto"}}>Manage Campaigns</Link>
                </Text>
              </UnstyledButton>
              <UnstyledButton className={classes.link} onClick={toggleReportsLinks}>
                <Center inline>
                  <Box component="span" mr={5}>
                    Reports
                  </Box>
                  <IconChevronDown size={16} color={theme.fn.primaryColor()} />
                </Center>
              </UnstyledButton>
              <Collapse in={ReportslinksOpened}>
                <UnstyledButton className={classes.link} pl="lg">
                  <Text className={classes.link}>
                    <Link to={selectedMemberWebsite.trim() !== '' ? "/campaign-reports" : "/settings"} style={{color: dark ? "white" : "black",textDecoration: "none",pointerEvents: loginMemberStatus === '3' ? "none" : "auto"}}>Campaign Reports</Link>
                  </Text>
                </UnstyledButton>
                <UnstyledButton className={classes.link} pl="lg">
                  <Text className={classes.link}>
                    <Link to={selectedMemberWebsite.trim() !== '' ? "/aggregated-reports" : "/settings"} style={{color: dark ? "white" : "black",textDecoration: "none",pointerEvents: loginMemberStatus === '3' ? "none" : "auto"}}>Aggregated Report</Link>
                  </Text>
                </UnstyledButton>
              </Collapse>
              <UnstyledButton className={classes.link}>
                <Text className={classes.link}>
                  <Link to={selectedMemberWebsite.trim() !== '' ? "/ad-lookup" : "/settings"} style={{color: dark ? "white" : "black",textDecoration: "none",pointerEvents: loginMemberStatus === '3' ? "none" : "auto"}}>Ad Lookup</Link>
                </Text>
              </UnstyledButton>
            </Collapse>
          </PermissionWrapper>
          <UnstyledButton className={classes.link} onClick={toggleInsightsLinks}>
            <Center inline>
              <Box component="span" mr={5}>
                Insights
              </Box>
              <IconChevronDown size={16} color={theme.fn.primaryColor()} />
            </Center>
          </UnstyledButton>
          <Collapse in={InsightslinksOpened}>
            <PermissionWrapper permission="heat_maps_access">
              <UnstyledButton className={classes.link}>
                <Text className={classes.link}>
                  <Link to={selectedMemberWebsite.trim() !== '' ? "/heat-maps" : "/settings"} style={{color: dark ? "white" : "black",textDecoration: "none",pointerEvents: loginMemberStatus === '3' ? "none" : "auto"}}>Heat Maps</Link>
                </Text>
              </UnstyledButton>
            </PermissionWrapper>
            <PermissionWrapper permission="scroll_maps_access">
              <UnstyledButton className={classes.link}>
                <Text className={classes.link}>
                  <Link to={selectedMemberWebsite.trim() !== '' ? "/scroll-maps" : "/settings"} style={{color: dark ? "white" : "black",textDecoration: "none",pointerEvents: loginMemberStatus === '3' ? "none" : "auto"}}>Scroll Maps</Link>
                </Text>
              </UnstyledButton>
            </PermissionWrapper>
            <PermissionWrapper permission="recordings_access">
              <UnstyledButton className={classes.link}>
                <Text className={classes.link}>
                  <Link to={selectedMemberWebsite.trim() !== '' ? "/recordings" : "/settings"} style={{color: dark ? "white" : "black",textDecoration: "none",pointerEvents: loginMemberStatus === '3' ? "none" : "auto"}}>Recordings</Link>
                </Text>
              </UnstyledButton>
            </PermissionWrapper>
          </Collapse>
{/*          <UnstyledButton className={classes.link}>
            <Text className={classes.link}>
              <Link to={landingurl} style={{color: dark ? "white" : "black",textDecoration: "none"}}>Landing Pages</Link>
            </Text>
          </UnstyledButton>*/}
          {!isAdLookupRole() && (
            <PermissionWrapper permission="operational_access">
{/*              <UnstyledButton className={classes.link}>
                <Text className={classes.link}>
                  <Link to="/landing-pages" style={{color: dark ? "white" : "black",textDecoration: "none"}}>Landing Pages</Link>
                </Text>
              </UnstyledButton>*/}
              <UnstyledButton className={classes.link}>
                <Text className={classes.link}>
                  <Link to="/settings" style={{color: dark ? "white" : "black",textDecoration: "none",pointerEvents: loginMemberStatus === '3' ? "none" : "auto"}}>Settings</Link>
                </Text>
              </UnstyledButton>
            </PermissionWrapper>
          )}
        </Drawer>
      </Box>
    </>
  );
}